import { TranslateService } from '@ngx-translate/core';

/**
 * Sorts items by their translated label for the active locale.
 * Call again on `TranslateService.onLangChange` so order follows the new language.
 */
export function sortByTranslatedLabel<T>(
  items: readonly T[],
  getLabelKey: (item: T) => string,
  translate: TranslateService,
): T[] {
  if (!items?.length) {
    return [];
  }
  const lang = translate.currentLang || undefined;
  return [...items].sort((a, b) => {
    const labelA = translate.instant(getLabelKey(a));
    const labelB = translate.instant(getLabelKey(b));
    return String(labelA).localeCompare(String(labelB), lang, { sensitivity: 'base' });
  });
}

/**
 * Convenience for option codes whose i18n key is `${prefix}${code}`
 * (e.g. prefix `frequentAccess.accessTypes.`).
 */
export function sortCodesByTranslatedLabel(
  codes: readonly string[],
  labelKeyPrefix: string,
  translate: TranslateService,
): string[] {
  return sortByTranslatedLabel(codes, (code) => `${labelKeyPrefix}${code}`, translate);
}
